import {
  DotsSixVerticalIcon,
  PencilSimpleIcon,
  PlusIcon,
  TrashSimpleIcon,
} from "@phosphor-icons/react";

import type { SectionDefinition } from "./config";

type Props = {
  definition: SectionDefinition;
  items: Array<Record<string, any>>;
  onAdd: () => void;
  onEdit: (item: Record<string, any>) => void;
  onDelete: (id: string) => void;
};

export const AdditionalItemList = ({ definition, items, onAdd, onEdit, onDelete }: Props) => {
  if (!items.length) {
    return (
      <div className="flex min-h-56 flex-col items-center justify-center rounded-2xl border border-dashed border-indigo-200 bg-white px-5 text-center">
        <span className="grid size-11 place-items-center rounded-xl bg-indigo-50 text-indigo-600">
          <PlusIcon size={20} weight="bold" />
        </span>
        <p className="mt-3 text-sm font-bold text-[#071451]">{definition.empty}</p>
        <p className="mt-1 max-w-sm text-[10px] leading-4 text-slate-500">
          Commencez par ajouter les informations les plus pertinentes pour le poste recherché.
        </p>
        <button
          type="button"
          onClick={onAdd}
          className="mt-4 h-10 rounded-xl bg-indigo-700 px-5 text-xs font-bold text-white hover:bg-indigo-800"
        >
          Ajouter maintenant
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-2.5">
      {items.map((item) => (
        <article
          key={item.id}
          className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-3 rounded-xl border border-slate-200 bg-white p-3.5 shadow-[0_4px_16px_rgba(15,23,42,0.03)]"
        >
          <DotsSixVerticalIcon size={16} className="cursor-grab text-slate-300" />
          <div className="min-w-0">
            <h3 className="truncate text-xs font-bold text-[#071451]">
              {definition.itemTitle(item) || "Sans titre"}
            </h3>
            <p className="mt-0.5 truncate text-[10px] text-slate-500">
              {definition.itemDescription(item)}
            </p>
          </div>
          <div className="flex items-center gap-1">
            <button
              type="button"
              onClick={() => onEdit(item)}
              aria-label="Modifier"
              className="grid size-8 place-items-center rounded-lg text-indigo-600 hover:bg-indigo-50"
            >
              <PencilSimpleIcon size={15} weight="bold" />
            </button>
            <button
              type="button"
              onClick={() => onDelete(item.id)}
              aria-label="Supprimer"
              className="grid size-8 place-items-center rounded-lg text-slate-400 hover:bg-rose-50 hover:text-rose-600"
            >
              <TrashSimpleIcon size={15} />
            </button>
          </div>
        </article>
      ))}
      <button
        type="button"
        onClick={onAdd}
        className="inline-flex h-10 items-center gap-2 rounded-xl border border-indigo-200 bg-white px-4 text-xs font-bold text-indigo-700 hover:border-indigo-400 hover:bg-indigo-50"
      >
        <PlusIcon size={15} weight="bold" /> Ajouter un autre élément
      </button>
    </div>
  );
};
